import type { PaymentProvider } from '../paymentTypes';
import { adyenAdapter } from './adyenAdapter';
import { primerAdapter } from './primerAdapter';
import { createStripeAdapter } from './stripeAdapter';
import type { CheckoutProviderAdapter } from './types';

export type { CheckoutFormProps, CheckoutProviderAdapter, InitDataContext } from './types';

export const CHECKOUT_PROVIDERS: Record<PaymentProvider, CheckoutProviderAdapter> = {
  adyen: adyenAdapter,
  stripe: createStripeAdapter('stripe'),
  stripe_gb: createStripeAdapter('stripe_gb'),
  primer: primerAdapter,
};

export const getCheckoutProviderAdapter = (code: string | null | undefined): CheckoutProviderAdapter | undefined =>
  code ? CHECKOUT_PROVIDERS[code as PaymentProvider] : undefined;
